import Animation from './modules/Animation'
import ContactForm from './modules/ContactForm'
import Discover from './modules/Discover'
import Iubenda from './modules/Iubenda'
import Marquee from './modules/Marquee'
import Menu from './modules/Menu'
import Popups from './modules/Popups'
import ScrollArrows from './modules/ScrollArrows'

export default class Main {
  constructor() {
    this.init()
  }

  init() {
    const body = document.querySelector('body')

    // run once when page loads
    window.addEventListener('load', () => {
      // remove the preloader
      setTimeout(function () {
        document.querySelector('.preloader').classList.add('preloader--hidden')
      }, 500)

      Animation.init()
      Iubenda.init()

      if (body.classList.contains('page--home')) {
        Discover.init()
        Marquee.init()
      } else {
        ScrollArrows.init()
      }

      if (body.classList.contains('page--contatti')) {
        ContactForm.init()
      }

      Menu.init()
      Popups.init()
    })

    let resizeTimeout
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout)
      resizeTimeout = setTimeout(() => {
        if (body.classList.contains('page--home')) {
          Discover.init()
          Marquee.init()
        }
      }, 300)
    })
  }
}

const main = new Main()
